import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { PriceTagIcon } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TripBookingPaymentInput } from '../../../lib/types/models/trip-booking/trip-booking-payment-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createDateStringSchema } from '../../../lib/utils/validations/date.validation'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledDateStringInput from '../../elements/inputs/controlled-date-string-input'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<TripBookingPaymentInput> & {
  className?: string
}

const formSchema: ZodType<TripBookingPaymentInput> = z.object({
  date: createDateStringSchema({ inputName: 'Date' }),
  amount: createNumberSchema('Montant du règlement (€)', { isPositive: true })
})

const TripBookingPaymentForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<TripBookingPaymentInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex gap-3', className)}>
          <FormField
            control={form.control}
            name={'amount'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput
                    {...field}
                    label={'Montant du règlement (€)'}
                    type="number"
                    icon={PriceTagIcon}
                    required
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'date'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledDateStringInput
                    {...field}
                    mode="over"
                    label={'Date'}
                    iconIsRight
                    type={'appointment'}
                    required
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons hasBorderTop {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default TripBookingPaymentForm
